import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  // #35073: non-blocking warning shown when man-days are entered but the rating
  // employee-count is still 0 (the class would otherwise rate as 0 employees).
  employeeCountWarning: {
    color: theme.colorPalette.orange_50,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
    paddingTop: theme.spacing(1)
  },
  liabilityContainer: {
    background: theme.colorPalette.green_90,
    width: '100%',
    padding: theme.spacing(6, 8),
    borderRadius: theme.sizes.roundCorners
  },
  sectionDivider: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(4, 0),
    width: '100%',
    borderTop: `1px solid ${theme.colorPalette.beige_25_op_30}`
  },
  acresRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
    backgroundColor: theme.colorPalette.green_100,
    color: theme.colorPalette.white,
    fontSize: 14,
    lineHeight: '20px',
    padding: `${theme.spacing(4)}px ${theme.spacing(6)}px !important`,
    borderRadius: theme.sizes.roundCorners
  },
  acresItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  acresLabel: {
    color: theme.colorPalette.beige_60
  },
  acresValue: {
    fontWeight: 600
  },
  exclusionsContainer: {
    border: `2px solid ${theme.colorPalette.green_80}`,
    borderRadius: theme.sizes.roundCorners,
    padding: theme.spacing(1, 4),
    width: '100%',
    marginBottom: theme.spacing(4)
  },
  // shared styles for liability sub-section components
  sectionContainer: {
    width: '100%'
  },
  headerText: {
    fontSize: 14,
    lineHeight: '20px',
    color: theme.colorPalette.white,
    height: 24
  },
  addFormContainer: {
    width: '100%',
    margin: theme.spacing(2, 0),
    border: `2px solid ${theme.colorPalette.green_80}`,
    borderRadius: theme.sizes.roundCorners,
    padding: theme.spacing(4, 8)
  },
  addButton: {
    padding: theme.spacing(2, 4)
  },
  addButtonRow: {
    marginTop: theme.spacing(2),
    justifyContent: 'flex-end'
  },
  addAnotherButton: {
    color: theme.colorPalette.white,
    textTransform: 'none',
    fontSize: 14,
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  checkboxDescription: {
    marginTop: theme.spacing(1),
    color: theme.colorPalette.beige_60,
    fontSize: 10
  },
  deleteInsuredButton: {
    marginLeft: theme.spacing(2)
  },
  selectFieldWrapper: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden'
  },
  insuredFieldWrapper: {
    flexGrow: 1
  },
  autocompleteHelperText: {
    color: theme.colorPalette.white
  },
  coverageLabel: {
    color: theme.colorPalette.beige_60,
    fontSize: 10,
    fontWeight: 600,
    textTransform: 'uppercase'
  },
  autocompleteOption: {
    color: theme.colorPalette.green_90,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    padding: theme.spacing(4)
  },
  notOnPolicyOption: {
    color: theme.colorPalette.orange_50,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    textDecoration: 'underline'
  },
  itemTitleWrapper: {
    padding: theme.spacing(1, 0),
    lineHeight: '20px'
  },
  itemTypeLabel: {
    color: theme.colorPalette.beige_60,
    fontSize: 10,
    fontWeight: 600,
    textTransform: 'uppercase'
  },
  coverageRadioLabel: {
    '&.MuiFormControlLabel-label': {
      color: theme.colorPalette.beige_25,
      fontFamily: '"Cabin"',
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '20px'
    }
  },
  goToLink: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: theme.colorPalette.white,
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  goToLinkCaret: {
    width: 16,
    height: 16,
    marginLeft: theme.spacing(1)
  },
  notOnPolicyTypeSelect: {
    marginBottom: theme.spacing(2)
  },
  notOnPolicyFieldsContainer: {
    marginBottom: theme.spacing(2)
  },
  onlyCoveredHere: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.colorPalette.beige_60,
    fontSize: 12,
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '16px'
  }
});

export default makeStyles(styles);
